"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiStepIconStyles = void 0;
// import { parseRSPToken } from '@rentspree/component-2023.utils.token-parser'
/*
 * TODO: Adjust to North Star Token
 * export const stepNumberInactiveBgColor = parseRSPToken(
 *   'rsp.comp.step-item.step-number-container.color',
 * )
 * export const stepNumberActiveBgColor = parseRSPToken(
 *   'rsp.comp.step-item.active.step-number-container.color',
 * )
 * export const stepNumberCompleteBgColor = parseRSPToken(
 *   'rsp.comp.step-item.complete.step-icon.color',
 * )
 * export const stepNumberTextColor =
 * parseRSPToken('rsp.comp.step-item.step-number-label-text.color')
 */
exports.muiStepIconStyles = {
    styleOverrides: {
        root: {
        /*
         * TODO: Adjust to North Star Token
         * color: stepNumberInactiveBgColor,
         * width: parseRSPToken('rsp.comp.step-item.step-number-container.width'),
         * height: parseRSPToken('rsp.comp.step-item.step-number-container.height'),
         * borderRadius: parseRSPToken('rsp.comp.step-item.step-number-container.shape'),
         *
         * '&.Mui-active': {
         *   color: stepNumberActiveBgColor,
         * },
         * '&.Mui-completed': {
         *   color: stepNumberCompleteBgColor,
         *   width: parseRSPToken('rsp.comp.step-item.complete.step-icon.width'),
         *   height: parseRSPToken('rsp.comp.step-item.complete.step-icon.height'),
         * },
         */
        },
    },
};
//# sourceMappingURL=step-icon.js.map